import { render, staticRenderFns } from "./bottom-sheet.vue?vue&type=template&id=0dcb91f2&scoped=true"
import script from "./bottom-sheet.vue?vue&type=script&lang=js"
export * from "./bottom-sheet.vue?vue&type=script&lang=js"
import style0 from "./bottom-sheet.vue?vue&type=style&index=0&id=0dcb91f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb91f2",
  null
  
)

export default component.exports